import modal from '@/utils/modal.js';
import eventbus from '@/utils/eventbus';

import { defineAsyncComponent } from 'vue';

const LevelList = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/widgets/LevelList');
});

function openLevelModal () {
  // @TODO ensure merchant config initialized etc?
  const m = modal.create(LevelList, true, {});
  m.body.setAttribute('data-gmf', ''); // This signals that we are already handling this element (so for example elAttach wont mess with it)
  m.body.classList.add('gmf-level-modal');
}

eventbus.on('openLevelModal', openLevelModal);

export default openLevelModal;
